import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { HStack, Pressable, Text, VStack } from "native-base";
import { AiFillCalendar } from "react-icons/ai";
import colors from "../../constants/colors";

const DatePickerCustomInput = forwardRef(({ value, onClick, label }, ref) => (
  <Pressable ref={ref} onPress={onClick}>
    <VStack>
      <Text color={colors.gray} fontSize="sm">
        {label}
      </Text>
      <HStack
        backgroundColor={colors.lighterGray}
        borderColor={colors.lightGray}
        borderWidth={1}
        borderRadius={5}
        paddingX={4}
        paddingY={1}
        space={2}>
        <AiFillCalendar />
        <Text fontSize="sm">{value}</Text>
      </HStack>
    </VStack>
  </Pressable>
));

DatePickerCustomInput.displayName = "DatePickerCustomInput";

DatePickerCustomInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.any,
  label: PropTypes.any.isRequired,
};

export default DatePickerCustomInput;
